import React from 'react';

import {BeerStylesTableBody} from './BeerStylesTableBody/BeerStylesTableBody';
import {BeerStylesTableHeader} from './BeerStylesTableHeader/BeerStylesTableHeader';

export const BeerStylesTable = () => {
  return (
    <div className="beer-styles__table-container">
      <div className="beer-styles-table">
        <BeerStylesTableHeader />
        <BeerStylesTableBody />
      </div>
    </div>
  );
};
